import { TimelineDocument } from "@heroncendre/schema";
import type { GuidedStrings } from "@heroncendre/player";
import weddingJson from "./timelines/wedding.json";
import chainesJson from "./chaines.json";

/**
 * ============================================================================
 *  parcours.ts — Les parcours narratifs de la visite
 * ----------------------------------------------------------------------------
 *  Ne contient que de la DONNÉE, lue depuis des fichiers : le parcours
 *  (`timelines/`) et les mots de l'interface (`chaines.json`). Aucun nom de
 *  scène ici — s'il en fallait un, ce serait un bug d'architecture.
 *
 *  La timeline est validée ici pour sa FORME ; sa cohérence avec le tour
 *  (scènes et guides qui existent bien) l'est par le player, qui a les deux
 *  documents sous les yeux.
 *
 *  Aujourd'hui la timeline est embarquée avec la coquille (quelques centaines
 *  d'octets de texte, versionnés avec le document). La publier à côté de
 *  `tour.json` sur R2 est prévu, mais demande au moteur de savoir la déposer.
 *
 *  ── Ajouter un parcours ────────────────────────────────────────────────────
 *
 *  Déposer `timelines/<nom>.json` et l'inscrire ci-dessous. La carte de l'accueil
 *  (`accueil.json`) qui le désigne par ce nom s'active d'elle-même : tant qu'il
 *  n'est pas inscrit, elle s'affiche « Bientôt disponible » et ne mène nulle part.
 * ==========================================================================*/

const PARCOURS: Record<string, unknown> = { wedding: weddingJson };

/**
 * Une seule instance par parcours. Le player recalcule son pilote à chaque
 * nouvel objet `timeline` reçu : en re-validant à chaque rendu, on lui en
 * présenterait un neuf à chaque fois.
 */
const valides = new Map<string, TimelineDocument>();

/** Le parcours de ce nom, ou undefined s'il n'existe pas (ou s'il n'y en a pas de demandé). */
export function parcoursDemande(nom: string | null | undefined): TimelineDocument | undefined {
  if (nom === null || nom === undefined || !(nom in PARCOURS)) return undefined;
  let timeline = valides.get(nom);
  if (!timeline) {
    timeline = TimelineDocument.parse(PARCOURS[nom]);
    valides.set(nom, timeline);
  }
  return timeline;
}

/** Ce parcours existe-t-il ? Sert aux cartes de l'accueil. */
export function parcoursExiste(nom: string): boolean {
  return nom in PARCOURS;
}

/**
 * Un parcours quelconque, pour que le lecteur de voix off existe dès l'accueil :
 * c'est lui qu'il faut « amorcer » dans le geste du clic sur une carte, avant
 * même de savoir lequel sera joué. Voir `Accueil.tsx`.
 */
export function premierParcours(): TimelineDocument | undefined {
  const [nom] = Object.keys(PARCOURS);
  return parcoursDemande(nom);
}

export const chaines: GuidedStrings = chainesJson;
